/* Wellness Hub OS — real-data blocks (rings, logger, trends, achievements).
   All data comes from the shared EWHQ data layer (sessions, lessons, goals). */
document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector(".wellness-os-wrapper")) return;

  const TYPE_META = {
    sauna: { label: "Sauna", emoji: "🔥" },
    cold_plunge: { label: "Cold Plunge", emoji: "🧊" },
    red_light: { label: "Red Light", emoji: "🔴" },
    breathwork: { label: "Breathwork", emoji: "🌬️" },
    meditation: { label: "Meditation", emoji: "🧘" },
    movement: { label: "Movement", emoji: "🏃" }
  };

  const $ = (id) => document.getElementById(id);
  const setText = (id, val) => { const el = $(id); if (el) el.innerText = val; };

  function startOfWeek() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    const day = (d.getDay() + 6) % 7; // Monday = 0
    d.setDate(d.getDate() - day);
    return d;
  }

  /* ============ ACTIVITY RINGS + STREAKS + GOALS ============ */
  function renderRings() {
    if (!$("rings-panel") || !window.EWHQ) return;
    const goals = window.EWHQ.getGoals();
    const weekStart = startOfWeek().getTime();
    const sessions = window.EWHQ.getSessions(8).filter(s => s.ts >= weekStart);

    const recoveryMin = sessions.reduce((sum, s) => sum + (s.minutes || 0), 0);
    const sessionCount = sessions.length;
    const lessonsThisWeek = window.EWHQ.completedSince
      ? window.EWHQ.completedSince(Math.ceil((Date.now() - weekStart) / 86400000))
      : 0;

    const rings = [
      { id: "ring-recovery", legend: "legend-recovery", goalEl: "goal-recovery", value: recoveryMin, goal: goals.recovery_minutes || 120, r: 82 },
      { id: "ring-sessions", legend: "legend-sessions", goalEl: "goal-sessions", value: sessionCount, goal: goals.sessions || 5, r: 64 },
      { id: "ring-lessons",  legend: "legend-lessons",  goalEl: "goal-lessons",  value: lessonsThisWeek, goal: goals.lessons || 3, r: 46 }
    ];
    rings.forEach(ring => {
      const el = $(ring.id);
      if (!el) return;
      const circ = 2 * Math.PI * ring.r;
      const pct = ring.goal > 0 ? Math.min(1, ring.value / ring.goal) : 0;
      el.style.strokeDasharray = circ;
      el.style.strokeDashoffset = circ * (1 - pct);
      setText(ring.legend, ring.value);
      setText(ring.goalEl, ring.goal);
    });

    setText("streak-current", "");
    const sc = $("streak-current"), sb = $("streak-best"), ad = $("active-days");
    if (sc) sc.innerHTML = window.EWHQ.currentStreak() + " <em>days</em>";
    if (sb) sb.innerHTML = window.EWHQ.bestStreak() + " <em>days</em>";
    if (ad) {
      const daySet = {};
      window.EWHQ.getSessions(30).forEach(s => { daySet[new Date(s.ts).toDateString()] = true; });
      ad.innerHTML = Object.keys(daySet).length + " <em>days</em>";
    }
  }

  function initGoalsEditor() {
    const toggle = $("goals-edit-toggle"), editor = $("goals-editor");
    if (!toggle || !editor || !window.EWHQ) return;
    if (toggle.dataset.bound) return;
    toggle.dataset.bound = "1";
    toggle.addEventListener("click", () => {
      editor.classList.toggle("open");
      if (editor.classList.contains("open")) {
        const goals = window.EWHQ.getGoals();
        $("goal-input-recovery").value = goals.recovery_minutes || 120;
        $("goal-input-sessions").value = goals.sessions || 5;
        $("goal-input-lessons").value = goals.lessons || 3;
      }
    });
    const saveBtn = $("goals-save-btn");
    if (saveBtn) saveBtn.addEventListener("click", () => {
      window.EWHQ.setGoals({
        recovery_minutes: $("goal-input-recovery").value,
        sessions: $("goal-input-sessions").value,
        lessons: $("goal-input-lessons").value
      });
      editor.classList.remove("open");
    });
  }

  /* ============ SESSION LOGGER ============ */
  let selectedType = null;

  function initLogger() {
    const panel = $("logger-panel");
    if (!panel || !window.EWHQ) return;
    if (panel.dataset.bound) return;
    panel.dataset.bound = "1";
    const typeBtns = panel.querySelectorAll(".logger-type-btn");
    const minutesInput = $("logger-minutes");
    const submitBtn = $("logger-submit");

    const updateSubmit = () => {
      submitBtn.disabled = !(selectedType && parseInt(minutesInput.value, 10) > 0);
    };

    typeBtns.forEach(btn => btn.addEventListener("click", () => {
      typeBtns.forEach(b => b.classList.remove("selected"));
      btn.classList.add("selected");
      selectedType = btn.dataset.type;
      updateSubmit();
    }));
    minutesInput.addEventListener("input", updateSubmit);

    submitBtn.addEventListener("click", () => {
      const minutes = parseInt(minutesInput.value, 10);
      if (!selectedType || !(minutes > 0)) return;
      window.EWHQ.logSession({ type: selectedType, minutes: minutes });
      minutesInput.value = "";
      updateSubmit();
      const fb = $("logger-feedback");
      if (fb) {
        const meta = TYPE_META[selectedType] || { label: selectedType };
        fb.innerText = "✓ Logged " + minutes + " min of " + meta.label;
        fb.classList.add("show");
        setTimeout(() => fb.classList.remove("show"), 2500);
      }
    });
  }

  function renderRecentSessions() {
    const list = $("recent-sessions-list");
    if (!list || !window.EWHQ) return;
    const sessions = window.EWHQ.getSessions().slice(-6).reverse();
    if (!sessions.length) {
      list.innerHTML = '<div class="rs-empty">No sessions logged yet — record your first one above.</div>';
      return;
    }
    list.innerHTML = sessions.map(s => {
      const meta = TYPE_META[s.type] || { label: s.type, emoji: "•" };
      const d = new Date(s.ts);
      const dateStr = d.toLocaleDateString(undefined, { month: "short", day: "numeric" }) +
        " " + d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
      return '<div class="recent-session-row">' +
        '<span class="rs-type">' + meta.emoji + " " + meta.label + "</span>" +
        '<span class="rs-meta">' + s.minutes + " min · " + dateStr +
        ' <button type="button" class="rs-delete" data-ts="' + s.ts + '" aria-label="Delete session">×</button></span>' +
        "</div>";
    }).join("");
    list.querySelectorAll(".rs-delete").forEach(btn => btn.addEventListener("click", () => {
      window.EWHQ.removeSession(parseInt(btn.dataset.ts, 10));
    }));
  }

  /* ============ EUS WEEKLY GRAPH — REAL DATA ============ */
  function renderWeeklyGraph() {
    const graph = $("eus-graph");
    if (!graph || !window.EWHQ) return;
    const sessions = window.EWHQ.getSessions(7);
    if (!sessions.length) return; // leave the decorative defaults if no data yet

    const byDay = {};
    sessions.forEach(s => {
      const key = new Date(s.ts).toDateString();
      byDay[key] = (byDay[key] || 0) + (s.minutes || 0);
    });

    const days = [];
    for (let i = 6; i >= 0; i--) {
      const d = new Date();
      d.setDate(d.getDate() - i);
      days.push({
        label: d.toLocaleDateString(undefined, { weekday: "narrow" }),
        minutes: byDay[d.toDateString()] || 0
      });
    }
    const max = Math.max(...days.map(d => d.minutes), 1);
    graph.innerHTML = days.map(d =>
      '<div class="graph-bar-wrapper">' +
      '<div class="graph-bar" data-height="' + Math.round((d.minutes / max) * 100) + '%" title="' + d.minutes + ' min"></div>' +
      '<span class="graph-day">' + d.label + "</span></div>"
    ).join("");
    requestAnimationFrame(() => {
      graph.querySelectorAll(".graph-bar").forEach(bar => { bar.style.height = bar.dataset.height; });
    });

    // Real weekly volumes override the assessment placeholders when data exists.
    const heat = sessions.filter(s => s.type === "sauna" || s.type === "red_light").reduce((n, s) => n + s.minutes, 0);
    const cold = sessions.filter(s => s.type === "cold_plunge").reduce((n, s) => n + s.minutes, 0);
    if (heat) setText("thermal-vol", heat + " min");
    if (cold) setText("cryo-vol", cold + " min");
  }

  /* ============ 8-WEEK TRENDS ============ */
  function renderTrends() {
    const graph = $("trend-graph");
    if (!graph || !window.EWHQ) return;
    const sessions = window.EWHQ.getSessions(56);

    const weeks = [];
    const thisWeekStart = startOfWeek().getTime();
    for (let i = 7; i >= 0; i--) {
      const start = thisWeekStart - i * 7 * 86400000;
      const end = start + 7 * 86400000;
      const inWeek = sessions.filter(s => s.ts >= start && s.ts < end);
      weeks.push({
        start: start,
        minutes: inWeek.reduce((n, s) => n + (s.minutes || 0), 0),
        current: i === 0
      });
    }
    const max = Math.max(...weeks.map(w => w.minutes), 1);
    graph.innerHTML = weeks.map(w => {
      const d = new Date(w.start);
      const label = (d.getMonth() + 1) + "/" + d.getDate();
      return '<div class="trend-col' + (w.current ? " current" : "") + '">' +
        '<span class="trend-value">' + (w.minutes || "") + "</span>" +
        '<div class="trend-bar" data-height="' + Math.round((w.minutes / max) * 100) + '%"></div>' +
        '<span class="trend-label">' + label + "</span></div>";
    }).join("");
    requestAnimationFrame(() => {
      graph.querySelectorAll(".trend-bar").forEach(bar => { bar.style.height = bar.dataset.height; });
    });

    const total = weeks.reduce((n, w) => n + w.minutes, 0);
    setText("trend-total", total + " min");
    setText("trend-avg", Math.round(total / 8) + " min");
    const cur = weeks[7].minutes, prev = weeks[6].minutes;
    const deltaEl = $("trend-delta");
    if (deltaEl) {
      if (!prev && !cur) deltaEl.innerText = "—";
      else {
        const diff = cur - prev;
        deltaEl.innerText = (diff >= 0 ? "+" : "") + diff + " min";
        deltaEl.style.color = diff >= 0 ? "#30d158" : "#ff4d4d";
      }
    }
    const byType = {};
    sessions.forEach(s => { byType[s.type] = (byType[s.type] || 0) + s.minutes; });
    const top = Object.keys(byType).sort((a, b) => byType[b] - byType[a])[0];
    setText("trend-top", top ? ((TYPE_META[top] || { label: top }).label) : "—");
  }

  /* ============ ACHIEVEMENTS ============ */
  const BADGES = [
    { icon: "🌱", name: "First Step", req: "Log your first session", test: p => p.sessionCount >= 1 },
    { icon: "📚", name: "Student", req: "Complete 1 lesson", test: p => p.lessons >= 1 },
    { icon: "🔥", name: "On Fire", req: "3-day streak", test: p => p.streak >= 3 },
    { icon: "⚡", name: "Unstoppable", req: "7-day streak", test: p => p.streak >= 7 },
    { icon: "🎯", name: "Dialed In", req: "Hit weekly recovery goal", test: p => p.weekMinutes >= p.goalMinutes && p.goalMinutes > 0 },
    { icon: "🧊", name: "Ice Veins", req: "10 cold sessions", test: p => p.coldCount >= 10 },
    { icon: "🌡️", name: "Heat Adapted", req: "500 thermal minutes", test: p => p.heatMinutes >= 500 },
    { icon: "🎓", name: "Scholar", req: "Complete 5 lessons", test: p => p.lessons >= 5 },
    { icon: "💰", name: "Coin Collector", req: "Earn 100 credits", test: p => p.credits >= 100 },
    { icon: "🏛️", name: "Centurion", req: "100 total sessions", test: p => p.sessionCount >= 100 }
  ];

  function renderAchievements() {
    const grid = $("badges-grid");
    if (!grid || !window.EWHQ) return;
    const all = window.EWHQ.getSessions();
    const weekStart = startOfWeek().getTime();
    const profile = {
      sessionCount: all.length,
      lessons: window.EWHQ.completedCount(),
      streak: Math.max(window.EWHQ.currentStreak(), window.EWHQ.bestStreak()),
      credits: window.EWHQ.getCredits(),
      coldCount: all.filter(s => s.type === "cold_plunge").length,
      heatMinutes: all.filter(s => s.type === "sauna" || s.type === "red_light").reduce((n, s) => n + s.minutes, 0),
      weekMinutes: all.filter(s => s.ts >= weekStart).reduce((n, s) => n + s.minutes, 0),
      goalMinutes: (window.EWHQ.getGoals() || {}).recovery_minutes || 0
    };
    grid.innerHTML = BADGES.map(b => {
      const unlocked = b.test(profile);
      return '<div class="badge-card' + (unlocked ? " unlocked" : "") + '">' +
        '<span class="badge-icon">' + b.icon + "</span>" +
        '<div class="badge-name">' + b.name + "</div>" +
        '<div class="badge-req">' + b.req + "</div></div>";
    }).join("");
  }

  /* ============ WELLNESS BLUEPRINT (from assessment) ============ */
  const BP_PILLARS = ["recovery", "sleep", "stress", "energy", "longevity"];
  const BP_META = {
    recovery:  { label: "Recovery", color: "#fa114f" },
    sleep:     { label: "Sleep Architecture", color: "#5e5ce6" },
    stress:    { label: "Stress Resilience", color: "#30d158" },
    energy:    { label: "Daily Energy", color: "#ffd60a" },
    longevity: { label: "Longevity Capacity", color: "#00d5ff" }
  };
  const BP_MODALITY_EMOJI = {
    sauna: "🔥", cold_plunge: "🧊", red_light: "🔴",
    breathwork: "🌬️", meditation: "🧘", movement: "🏃"
  };

  function bpGrade(index) {
    if (index >= 85) return { g: "Elite — Peak Ecosystem", s: "Protecting and compounding a rare baseline." };
    if (index >= 70) return { g: "Strong — Well Optimized", s: "Solid foundation with clear upside in your focus pillars." };
    if (index >= 55) return { g: "Developing — Real Upside", s: "Consistency in your weak pillars changes everything." };
    if (index >= 40) return { g: "Strained — Needs Support", s: "Several systems are running under-recovered." };
    return { g: "Depleted — Priority Reset", s: "Starting with nervous-system recovery." };
  }

  function renderBlueprint() {
    const panel = $("blueprint-panel");
    if (!panel || !window.EWHQ) return;
    const a = window.EWHQ.getAssessment();
    const emptyEl = $("blueprint-empty");
    const popEl = $("blueprint-populated");

    if (!a || !a.pillars) {
      if (emptyEl) emptyEl.style.display = "block";
      if (popEl) popEl.style.display = "none";
      return;
    }
    if (emptyEl) emptyEl.style.display = "none";
    if (popEl) popEl.style.display = "block";

    const index = a.wellness_index || a.computed_score || 0;
    const grade = bpGrade(index);
    setText("bp-grade", grade.g);
    setText("bp-grade-sub", grade.s);

    const ring = $("bp-ring");
    const circ = 2 * Math.PI * 50;
    if (ring) {
      ring.style.strokeDasharray = circ;
      requestAnimationFrame(() => { ring.style.strokeDashoffset = circ * (1 - index / 100); });
    }
    const numEl = $("bp-index");
    if (numEl) { let c = 0; const t = setInterval(() => { c += 2; if (c >= index) { c = index; clearInterval(t); } numEl.innerText = c; }, 22); }

    const focus = a.focus_areas || [];
    const pillars = a.pillars;
    const list = $("bp-pillars");
    if (list) {
      const ordered = BP_PILLARS.slice().filter(p => pillars[p] != null).sort((x, y) => pillars[y] - pillars[x]);
      list.innerHTML = ordered.map(p => {
        const meta = BP_META[p];
        const isFocus = focus.indexOf(p) !== -1;
        return '<div class="bp-pillar">' +
          '<span class="bp-pillar-name"><span class="bp-dot" style="background:' + meta.color + ';"></span>' + meta.label +
          (isFocus ? ' <span style="color:' + meta.color + ';font-size:0.6rem;">●</span>' : "") + "</span>" +
          '<span class="bp-pillar-track"><span class="bp-pillar-fill" data-w="' + pillars[p] + '" style="background:' + meta.color + ';"></span></span>' +
          '<span class="bp-pillar-val">' + pillars[p] + "</span></div>";
      }).join("");
      requestAnimationFrame(() => {
        list.querySelectorAll(".bp-pillar-fill").forEach(bar => { bar.style.width = bar.dataset.w + "%"; });
      });
    }

    const plan = a.recommended_plan || [];
    const planEl = $("bp-plan");
    if (planEl) {
      planEl.innerHTML = plan.map(p =>
        '<div class="bp-plan-chip"><div class="bp-plan-top"><span class="bp-plan-emoji">' +
        (BP_MODALITY_EMOJI[p.type] || "•") + '</span><span class="bp-plan-name">' + p.label + "</span></div>" +
        '<span class="bp-plan-dose">' + p.sessions + "×/wk · " + p.minutes + " min</span></div>"
      ).join("");
    }
  }

  /* ============ VIDEO SPOTLIGHT (Apple Fitness+-style carousel) ============ */
  function initSpotlight() {
    document.querySelectorAll("[data-spotlight]").forEach(carousel => {
      if (carousel.dataset.spotInit) return; // don't double-bind on editor reloads
      carousel.dataset.spotInit = "1";
      const track = carousel.querySelector("[data-spot-track]");
      const dotsWrap = carousel.querySelector("[data-spot-dots]");
      if (!track) return;
      const slides = Array.from(track.querySelectorAll(".spot-slide"));
      if (!slides.length) return;

      // Pagination dots (hidden when there's only one card)
      let dots = [];
      if (dotsWrap && slides.length > 1) {
        dotsWrap.innerHTML = slides.map((_, i) =>
          '<button type="button" class="spot-dot" role="tab" aria-label="Go to slide ' + (i + 1) + '"></button>'
        ).join("");
        dots = Array.from(dotsWrap.children);
        dots.forEach((dot, i) => dot.addEventListener("click", () => {
          track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" });
        }));
      }

      function activeIndex() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }
      function goTo(index) {
        const next = (index + slides.length) % slides.length; // wraps around
        track.scrollTo({ left: slides[next].offsetLeft, behavior: "smooth" });
      }
      function updateDots() {
        const idx = activeIndex();
        dots.forEach((dot, i) => dot.classList.toggle("active", i === idx));
      }

      // Hover arrows for mouse users (manual slider, no timer needed)
      if (slides.length > 1) {
        ["prev", "next"].forEach(dir => {
          const arrow = document.createElement("button");
          arrow.type = "button";
          arrow.className = "spot-arrow " + dir;
          arrow.setAttribute("aria-label", dir === "prev" ? "Previous card" : "Next card");
          arrow.innerHTML = dir === "prev"
            ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>'
            : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
          arrow.addEventListener("click", () => goTo(activeIndex() + (dir === "prev" ? -1 : 1)));
          carousel.appendChild(arrow);
        });
      }

      // Click-and-drag sliding for mouse users
      let suppressClick = false;
      let drag = null;
      track.addEventListener("pointerdown", event => {
        if (event.pointerType !== "mouse" || event.button !== 0) return;
        drag = { startX: event.clientX, startScroll: track.scrollLeft, moved: false };
      });
      track.addEventListener("pointermove", event => {
        if (!drag) return;
        const dx = event.clientX - drag.startX;
        if (!drag.moved && Math.abs(dx) > 8) {
          drag.moved = true;
          track.classList.add("dragging");
          track.setPointerCapture(event.pointerId);
        }
        if (drag.moved) track.scrollLeft = drag.startScroll - dx;
      });
      function endDrag() {
        if (!drag) return;
        if (drag.moved) {
          suppressClick = true;
          setTimeout(() => { suppressClick = false; }, 80);
          track.classList.remove("dragging");
          goTo(Math.max(0, Math.min(slides.length - 1, activeIndex()))); // settle on nearest card
        }
        drag = null;
      }
      track.addEventListener("pointerup", endDrag);
      track.addEventListener("pointercancel", endDrag);
      let ticking = false;
      track.addEventListener("scroll", () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { updateDots(); ticking = false; });
      }, { passive: true });
      updateDots();

      // Optional auto-advance (Apple-banner style). Pauses on hover/touch,
      // in background tabs, and while the theater is playing a video.
      const autoplaySec = parseInt(carousel.dataset.autoplay, 10);
      const reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (autoplaySec > 0 && slides.length > 1 && !reducedMotion) {
        let paused = false;
        setInterval(() => {
          if (paused || document.hidden || theaterState) return;
          const next = (activeIndex() + 1) % slides.length;
          track.scrollTo({ left: slides[next].offsetLeft, behavior: "smooth" });
        }, autoplaySec * 1000);
        carousel.addEventListener("pointerenter", () => { paused = true; });
        carousel.addEventListener("pointerleave", () => { paused = false; });
        carousel.addEventListener("touchstart", () => { paused = true; }, { passive: true });
        carousel.addEventListener("touchend", () => {
          setTimeout(() => { paused = false; }, 4000); // grace period after a swipe
        }, { passive: true });
      }

      // Videos stay paused in the card. Clicking a slide opens the theater:
      // the video moves into a full-viewport overlay (works even where native
      // fullscreen is blocked, e.g. the theme editor preview iframe) and
      // native fullscreen is requested on top of it. Closing the theater
      // returns the video to its card, paused and muted.
      slides.forEach(slide => {
        const video = slide.querySelector("[data-spot-video]");
        if (!video) return;
        slide.addEventListener("click", event => {
          if (suppressClick) return; // it was a drag, not a click
          if (event.target.closest("a")) return; // chevron link keeps navigating
          openTheater(slide, video);
        });
        slide.addEventListener("keydown", event => {
          if (event.key !== "Enter" && event.key !== " ") return;
          if (event.target.closest("a")) return;
          event.preventDefault();
          openTheater(slide, video);
        });
        video.addEventListener("webkitendfullscreen", closeTheater); // iOS native player exit
      });
    });
  }

  /* Shared theater overlay (built once, reused by every spotlight card) */
  let theaterEl = null;
  let theaterState = null; // { video, home, slide }

  function getTheater() {
    if (theaterEl) return theaterEl;
    theaterEl = document.createElement("div");
    theaterEl.className = "spot-theater";
    theaterEl.innerHTML =
      '<button type="button" class="spot-theater-close" aria-label="Close video">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
      "</button>";
    document.body.appendChild(theaterEl);
    theaterEl.querySelector(".spot-theater-close").addEventListener("click", closeTheater);
    theaterEl.addEventListener("click", event => {
      if (event.target === theaterEl) closeTheater(); // backdrop click
    });
    document.addEventListener("keydown", event => {
      if (event.key === "Escape" && theaterState) closeTheater();
    });
    document.addEventListener("fullscreenchange", () => {
      // Leaving native fullscreen (via Esc or system UI) closes the theater too.
      if (!document.fullscreenElement && theaterState) closeTheater();
    });
    return theaterEl;
  }

  function openTheater(slide, video) {
    if (theaterState) closeTheater();

    // iPhone Safari has no element fullscreen — use the native video player.
    if (!document.body.requestFullscreen && video.webkitEnterFullscreen) {
      theaterState = { video: video, home: video.parentElement, slide: slide, iosNative: true };
      slide.classList.add("is-playing");
      video.muted = false;
      video.controls = true;
      video.webkitEnterFullscreen();
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
      return;
    }

    const theater = getTheater();
    theaterState = { video: video, home: video.parentElement, slide: slide };
    slide.classList.add("is-playing");
    theater.appendChild(video);
    theater.classList.add("open");
    document.body.style.overflow = "hidden";

    video.muted = false;
    video.controls = true;
    video.setAttribute("controlslist", "nodownload");
    const p = video.play();
    if (p && p.catch) p.catch(() => {});

    // Best-effort native fullscreen on top of the overlay; the overlay
    // already covers the viewport if this is blocked.
    if (theater.requestFullscreen) theater.requestFullscreen().catch(() => {});
  }

  function closeTheater() {
    if (!theaterState) return;
    const state = theaterState;
    theaterState = null;

    state.video.pause();
    state.video.muted = true;
    state.video.controls = false;
    state.slide.classList.remove("is-playing");

    if (!state.iosNative) {
      state.home.appendChild(state.video); // put the video back in its card
      if (theaterEl) theaterEl.classList.remove("open");
      document.body.style.overflow = "";
      if (document.fullscreenElement && document.exitFullscreen) {
        document.exitFullscreen().catch(() => {});
      }
    }
  }

  /* ============ TPI CHECK-IN LOOP (Phase 3 feedback) ============
     Shows a banner in the hub: prompt a re-assessment every 30 days,
     and celebrate the score trend when there's history. */
  function renderTpiCheckin() {
    if (!window.EWHQ) return;
    const wrapper = document.querySelector(".wellness-os-wrapper");
    if (!wrapper) return;
    let banner = document.getElementById("tpi-checkin-banner");
    if (!banner) {
      banner = document.createElement("div");
      banner.id = "tpi-checkin-banner";
      banner.style.cssText =
        "display:none;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;" +
        "margin:0 0 24px;padding:18px 22px;border-radius:16px;" +
        "background:rgba(0,113,227,0.12);border:1px solid rgba(0,113,227,0.5);color:inherit;";
      wrapper.prepend(banner);
    }

    const hist = window.EWHQ.getPref("tpi_history") || [];
    const assessment = window.EWHQ.getAssessment();
    const lastTs = hist.length ? hist[hist.length - 1].ts
      : (assessment && assessment.completed_at ? assessment.completed_at * 1000 : 0);
    const daysSince = lastTs ? Math.floor((Date.now() - lastTs) / 86400000) : null;

    let msg = "", cta = "Take the TPI Assessment";
    if (!lastTs) {
      msg = "<strong>Get your Total Performance Index.</strong> A 3-minute assessment builds your personalized protocol and unlocks progress tracking.";
    } else if (daysSince >= 30) {
      msg = "<strong>Time for your TPI check-in.</strong> It's been " + daysSince + " days — retake the assessment to measure what your protocol changed.";
      cta = "Retake My Assessment";
    } else if (hist.length >= 2) {
      const first = hist[0].score, last = hist[hist.length - 1].score;
      const arrow = last >= first ? "&uarr;" : "&darr;";
      msg = "<strong>TPI trend: " + first + " " + arrow + " " + last + "</strong> across " + hist.length +
        " assessments. Next check-in in " + Math.max(1, 30 - daysSince) + " days.";
      cta = "View Assessment";
    } else {
      banner.style.display = "none";
      return;
    }
    banner.innerHTML = "<span style='line-height:1.5;'>" + msg + "</span>" +
      "<a href='/pages/wellness-assessment' style='flex-shrink:0;background:#0071e3;color:#fff;text-decoration:none;" +
      "padding:10px 22px;border-radius:999px;font-weight:600;font-size:0.95rem;'>" + cta + "</a>";
    banner.style.display = "flex";
  }

  /* ============ HABIT HEATMAP (GitHub-style, ~26 weeks) ============ */
  function renderHeatmap() {
    const grid = $("heatmap-grid");
    if (!grid || !window.EWHQ) return;
    const WEEKS = 26;
    const byDay = {};
    window.EWHQ.getSessions(WEEKS * 7).forEach(s => {
      const key = new Date(s.ts).toDateString();
      byDay[key] = (byDay[key] || 0) + (s.minutes || 0);
    });
    // Lesson completions count as active days too.
    const state = window.EWHQ.getState();
    Object.keys(state.completed || {}).forEach(id => {
      const v = state.completed[id];
      if (typeof v === "number") {
        const key = new Date(v).toDateString();
        byDay[key] = (byDay[key] || 0) + 20; // treat a lesson like ~20 active min
      }
    });

    const level = m => (m <= 0 ? 0 : m < 15 ? 1 : m < 40 ? 2 : m < 75 ? 3 : 4);
    const today = new Date(); today.setHours(0, 0, 0, 0);
    // Start on the Monday of the earliest visible week.
    const start = new Date(today);
    start.setDate(start.getDate() - (WEEKS * 7 - 1));
    const startDow = (start.getDay() + 6) % 7;
    start.setDate(start.getDate() - startDow);

    let cells = "", activeDays = 0, totalMin = 0;
    const d = new Date(start);
    while (d <= today) {
      const min = byDay[d.toDateString()] || 0;
      if (min > 0) { activeDays++; totalMin += min; }
      const lvl = level(min);
      const label = d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
      cells += '<div class="hm-cell l' + lvl + '" title="' + label + ': ' + min + ' min"></div>';
      d.setDate(d.getDate() + 1);
    }
    grid.innerHTML = cells;
    const summary = $("heatmap-summary");
    if (summary) summary.textContent = activeDays + " active days in the last " + WEEKS + " weeks";
  }

  /* ============ MICRO CHECK-IN (single-pillar re-score) ============ */
  const MICRO_PILLARS = {
    recovery:  { label: "Recovery",  q: "How recovered does your body feel right now? (0 = wiped out, 100 = fully fresh)" },
    sleep:     { label: "Sleep",     q: "How was your sleep this week? (0 = terrible, 100 = deeply restorative)" },
    stress:    { label: "Stress",    q: "How regulated is your stress today? (0 = overwhelmed, 100 = calm & in control)" },
    energy:    { label: "Energy",    q: "How steady is your energy today? (0 = crashing, 100 = strong all day)" },
    longevity: { label: "Longevity", q: "How consistent were your longevity habits this week? (0 = none, 100 = dialed in)" }
  };
  function initMicroCheckin() {
    const panel = $("micro-panel");
    if (!panel || !window.EWHQ || panel.dataset.bound) return;
    panel.dataset.bound = "1";
    const pills = $("micro-pills");
    const wrap = $("micro-slider-wrap");
    const qEl = $("micro-q");
    const range = $("micro-range");
    const valEl = $("micro-range-val");
    const saveBtn = $("micro-save");
    const fb = $("micro-feedback");
    let activePillar = null;

    if (pills) {
      pills.innerHTML = Object.keys(MICRO_PILLARS).map(k =>
        '<button type="button" class="micro-pill" data-pillar="' + k + '">' + MICRO_PILLARS[k].label + "</button>"
      ).join("");
      pills.querySelectorAll(".micro-pill").forEach(btn => btn.addEventListener("click", () => {
        activePillar = btn.dataset.pillar;
        pills.querySelectorAll(".micro-pill").forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
        const a = window.EWHQ.getAssessment();
        const cur = (a && a.pillars && a.pillars[activePillar] != null) ? a.pillars[activePillar] : 50;
        if (qEl) qEl.textContent = MICRO_PILLARS[activePillar].q;
        if (range) range.value = cur;
        if (valEl) valEl.textContent = cur;
        if (wrap) wrap.style.display = "block";
        if (fb) fb.textContent = "";
      }));
    }
    if (range && valEl) range.addEventListener("input", () => { valEl.textContent = range.value; });
    if (saveBtn) saveBtn.addEventListener("click", () => {
      if (!activePillar) return;
      window.EWHQ.updatePillar(activePillar, parseInt(range.value, 10));
      if (fb) fb.textContent = "✓ " + MICRO_PILLARS[activePillar].label + " updated — your TPI has been recalculated.";
    });
  }
  function renderMicroCheckin() {
    const panel = $("micro-panel");
    if (!panel || !window.EWHQ) return;
    const has = !!window.EWHQ.getAssessment();
    const locked = $("micro-locked"), active = $("micro-active");
    if (locked) locked.style.display = has ? "none" : "block";
    if (active) active.style.display = has ? "block" : "none";
  }

  /* ============ REDEEMABLE CREDITS STORE ============ */
  function initCreditsStore() {
    const panel = $("credits-store-panel");
    if (!panel || !window.EWHQ || panel.dataset.bound) return;
    panel.dataset.bound = "1";
    panel.querySelectorAll(".store-card").forEach(card => {
      const btn = card.querySelector(".store-redeem-btn");
      if (!btn) return;
      btn.addEventListener("click", () => {
        const cost = parseInt(card.dataset.cost, 10) || 0;
        const code = card.dataset.code || "";
        const title = card.dataset.title || "Reward";
        const id = card.dataset.rewardId || title;
        // Already redeemed? just re-reveal the code.
        const prior = window.EWHQ.getRedemptions().find(r => r.id === id);
        if (prior) { revealCode(card, prior.code || code); return; }
        if (!window.EWHQ.spendCredits(cost)) {
          btn.textContent = "Not enough credits";
          setTimeout(() => { btn.textContent = "Redeem"; }, 1800);
          return;
        }
        window.EWHQ.addRedemption({ id: id, title: title, cost: cost, code: code });
        revealCode(card, code);
      });
    });
    renderCreditsStore();
  }
  function revealCode(card, code) {
    const box = card.querySelector(".store-card-code");
    const btn = card.querySelector(".store-redeem-btn");
    if (box) { box.hidden = false; const c = box.querySelector("code"); if (c) c.textContent = code || "Applied at checkout"; }
    if (btn) { btn.textContent = "Redeemed"; btn.disabled = true; }
  }
  function renderCreditsStore() {
    const panel = $("credits-store-panel");
    if (!panel || !window.EWHQ) return;
    const bal = window.EWHQ.getCredits();
    setText("store-credit-balance", bal);
    const redeemed = window.EWHQ.getRedemptions();
    panel.querySelectorAll(".store-card").forEach(card => {
      const cost = parseInt(card.dataset.cost, 10) || 0;
      const id = card.dataset.rewardId || card.dataset.title;
      const btn = card.querySelector(".store-redeem-btn");
      const prior = redeemed.find(r => r.id === id);
      if (prior) { revealCode(card, prior.code || card.dataset.code); return; }
      if (btn) { btn.disabled = bal < cost; if (!btn.disabled) btn.textContent = "Redeem"; }
    });
  }

  /* ============ WEARABLE / CSV IMPORT ============ */
  function initWearableImport() {
    const panel = $("wearable-panel");
    if (!panel || !window.EWHQ || panel.dataset.bound) return;
    panel.dataset.bound = "1";
    const input = $("wearable-file");
    const drop = $("wearable-drop");
    const fb = $("wearable-feedback");
    const TYPE_ALIASES = {
      sauna: "sauna", heat: "sauna", infrared: "sauna",
      cold: "cold_plunge", cold_plunge: "cold_plunge", coldplunge: "cold_plunge", ice: "cold_plunge", plunge: "cold_plunge",
      red_light: "red_light", redlight: "red_light", rlt: "red_light",
      breath: "breathwork", breathwork: "breathwork",
      meditation: "meditation", meditate: "meditation", mindfulness: "meditation",
      movement: "movement", workout: "movement", exercise: "movement", run: "movement", walk: "movement", strength: "movement", cardio: "movement"
    };
    function normType(raw) {
      const k = String(raw || "").toLowerCase().trim().replace(/\s+/g, "_");
      return TYPE_ALIASES[k] || (TYPE_META[k] ? k : "movement");
    }
    function parseCsv(text) {
      const lines = text.split(/\r?\n/).filter(l => l.trim());
      if (!lines.length) return { added: 0, skipped: 0 };
      let startIdx = 0;
      const header = lines[0].toLowerCase();
      const hasHeader = /date|type|min/.test(header);
      let cols = { date: 0, type: 1, minutes: 2 };
      if (hasHeader) {
        const h = lines[0].split(",").map(s => s.trim().toLowerCase());
        cols.date = h.findIndex(x => /date|day|start/.test(x)); if (cols.date < 0) cols.date = 0;
        cols.type = h.findIndex(x => /type|activity|workout|modality/.test(x)); if (cols.type < 0) cols.type = 1;
        cols.minutes = h.findIndex(x => /min|duration|length/.test(x)); if (cols.minutes < 0) cols.minutes = 2;
        startIdx = 1;
      }
      let added = 0, skipped = 0;
      for (let i = startIdx; i < lines.length; i++) {
        const parts = lines[i].split(",");
        const dateRaw = (parts[cols.date] || "").trim();
        const minutes = parseInt((parts[cols.minutes] || "").replace(/[^\d.]/g, ""), 10);
        if (!dateRaw || !(minutes > 0)) { skipped++; continue; }
        const ts = Date.parse(dateRaw);
        if (isNaN(ts)) { skipped++; continue; }
        window.EWHQ.logSession({ type: normType(parts[cols.type]), minutes: minutes, ts: ts });
        added++;
      }
      return { added: added, skipped: skipped };
    }
    function handleFile(file) {
      if (!file) return;
      const reader = new FileReader();
      reader.onload = e => {
        try {
          const res = parseCsv(String(e.target.result || ""));
          if (fb) {
            fb.style.color = res.added ? "#30d158" : "#ff6b6b";
            fb.textContent = res.added
              ? "✓ Imported " + res.added + " session" + (res.added === 1 ? "" : "s") + (res.skipped ? " (" + res.skipped + " rows skipped)" : "") + "."
              : "No valid rows found. Expected columns: date, type, minutes.";
          }
        } catch (err) {
          if (fb) { fb.style.color = "#ff6b6b"; fb.textContent = "Could not read that file."; }
        }
      };
      reader.readAsText(file);
    }
    if (input) input.addEventListener("change", () => handleFile(input.files && input.files[0]));
    if (drop) {
      ["dragover", "dragenter"].forEach(ev => drop.addEventListener(ev, e => { e.preventDefault(); drop.classList.add("dragover"); }));
      ["dragleave", "drop"].forEach(ev => drop.addEventListener(ev, e => { e.preventDefault(); drop.classList.remove("dragover"); }));
      drop.addEventListener("drop", e => { if (e.dataTransfer && e.dataTransfer.files) handleFile(e.dataTransfer.files[0]); });
    }
  }

  /* ============ STREAK AT-RISK ALERT ============ */
  function renderStreakAlert() {
    if (!window.EWHQ) return;
    const wrapper = document.querySelector(".wellness-os-wrapper");
    if (!wrapper) return;
    let banner = document.getElementById("streak-alert-banner");
    const streak = window.EWHQ.currentStreak();
    // "At risk" = you have a streak of 2+, but nothing logged today yet.
    const todayKey = new Date().toDateString();
    const loggedToday = window.EWHQ.getSessions(1).some(s => new Date(s.ts).toDateString() === todayKey);
    const state = window.EWHQ.getState();
    const doneToday = Object.keys(state.completed || {}).some(id => {
      const v = state.completed[id];
      return typeof v === "number" && new Date(v).toDateString() === todayKey;
    });
    const atRisk = streak >= 2 && !loggedToday && !doneToday;
    if (!atRisk) { if (banner) banner.style.display = "none"; return; }
    if (!banner) {
      banner = document.createElement("div");
      banner.id = "streak-alert-banner";
      banner.style.cssText =
        "display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;" +
        "margin:0 0 24px;padding:16px 22px;border-radius:16px;" +
        "background:rgba(245,196,83,0.14);border:1px solid rgba(245,196,83,0.55);color:inherit;";
      wrapper.prepend(banner);
    }
    banner.innerHTML =
      "<span style='line-height:1.5;'>🔥 <strong>Keep your " + streak + "-day streak alive.</strong> " +
      "Log a session today so you don't lose your momentum.</span>" +
      "<a href='#logger-panel' style='flex-shrink:0;background:#f5c453;color:#111;text-decoration:none;" +
      "padding:10px 22px;border-radius:999px;font-weight:600;font-size:0.95rem;'>Log a session</a>";
    banner.style.display = "flex";
  }

  /* ============ GOAL AUTO-TUNING ============ */
  function renderGoalTuning() {
    const panel = $("rings-panel");
    if (!panel || !window.EWHQ) return;
    let tip = document.getElementById("goal-tuning-tip");
    const goals = window.EWHQ.getGoals();
    // Look at the last 3 completed weeks of recovery minutes.
    const now = startOfWeek().getTime();
    const weekly = [];
    for (let i = 1; i <= 3; i++) {
      const start = now - i * 7 * 86400000, end = start + 7 * 86400000;
      const mins = window.EWHQ.getSessions(28).filter(s => s.ts >= start && s.ts < end).reduce((n, s) => n + s.minutes, 0);
      weekly.push(mins);
    }
    const logged = weekly.filter(m => m > 0);
    if (logged.length < 2) { if (tip) tip.style.display = "none"; return; }
    const avg = Math.round(logged.reduce((a, b) => a + b, 0) / logged.length);
    const goal = goals.recovery_minutes || 120;
    let msg = null, suggested = goal;
    if (avg >= goal * 1.2) { suggested = Math.round((avg * 1.1) / 10) * 10; msg = "You're consistently beating your recovery goal. Raise it to " + suggested + " min/week?"; }
    else if (avg > 0 && avg < goal * 0.6) { suggested = Math.max(30, Math.round((avg * 1.15) / 10) * 10); msg = "Your goal looks ambitious lately. Reset it to a stickier " + suggested + " min/week?"; }
    if (!msg) { if (tip) tip.style.display = "none"; return; }
    if (!tip) {
      tip = document.createElement("div");
      tip.id = "goal-tuning-tip";
      tip.style.cssText = "margin-top:14px;padding:12px 14px;border-radius:12px;background:rgba(0,113,227,0.12);border:1px solid rgba(0,113,227,0.4);font-size:0.85rem;line-height:1.45;display:flex;gap:10px;align-items:center;justify-content:space-between;flex-wrap:wrap;";
      panel.querySelector(".glass-panel, #rings-panel") ? panel.appendChild(tip) : panel.appendChild(tip);
    }
    tip.innerHTML = "<span>" + msg + "</span>" +
      "<button type='button' id='goal-tune-apply' style='cursor:pointer;border:none;background:#0071e3;color:#fff;border-radius:8px;padding:6px 14px;font-family:inherit;font-size:0.82rem;font-weight:600;'>Apply</button>";
    tip.style.display = "flex";
    const apply = document.getElementById("goal-tune-apply");
    if (apply) apply.onclick = () => { window.EWHQ.setGoals({ recovery_minutes: suggested }); tip.style.display = "none"; };
  }

  /* ============ WEEKLY RECAP (Klaviyo re-engagement) ============
     Fires at most once every 7 days for logged-in members with an email,
     summarizing the past week so a Klaviyo flow can send a recap. */
  function maybeFireWeeklyRecap() {
    const cfg = window.EWHQ_HUB_CONFIG || {};
    if (!window.EWHQ || !cfg.klaviyoPublicKey || !cfg.customerEmail) return;
    const last = window.EWHQ.getPref("last_weekly_recap") || 0;
    if (Date.now() - last < 7 * 86400000) return;

    const weekStart = startOfWeek().getTime();
    const sessions = window.EWHQ.getSessions(7).filter(s => s.ts >= weekStart);
    const minutes = sessions.reduce((n, s) => n + (s.minutes || 0), 0);
    const goals = window.EWHQ.getGoals();
    const byType = {};
    sessions.forEach(s => { byType[s.type] = (byType[s.type] || 0) + s.minutes; });
    const top = Object.keys(byType).sort((a, b) => byType[b] - byType[a])[0] || "";

    const props = {
      week_sessions: sessions.length,
      week_minutes: minutes,
      recovery_goal: goals.recovery_minutes || 0,
      goal_hit: minutes >= (goals.recovery_minutes || 0),
      current_streak: window.EWHQ.currentStreak(),
      best_streak: window.EWHQ.bestStreak(),
      lessons_this_week: window.EWHQ.completedSince(7),
      top_modality: top ? ((TYPE_META[top] || { label: top }).label) : "",
      credits: window.EWHQ.getCredits()
    };
    const evt = {
      data: {
        type: "event",
        attributes: {
          metric: { name: "Weekly Wellness Recap" },
          profile: { email: cfg.customerEmail, first_name: cfg.customerName || undefined },
          properties: props,
          time: new Date().toISOString()
        }
      }
    };
    fetch("https://a.klaviyo.com/client/events/?company_id=" + cfg.klaviyoPublicKey, {
      method: "POST",
      headers: { "Content-Type": "application/json", "revision": "2023-02-22" },
      body: JSON.stringify(evt)
    }).then(() => { window.EWHQ.setPref("last_weekly_recap", Date.now()); }).catch(() => {});
  }

  /* ============ RECOVERY TIMER ============ */
  // Guided phase timer with presets (sauna / cold / contrast rounds / custom).
  // Keeps the screen awake, beeps + vibrates + notifies on phase changes, and
  // auto-logs the finished session into the EWHQ data layer per modality.
  function initRecoveryTimer() {
    const panel = $("rt-panel");
    if (!panel || panel.dataset.bound) return;
    panel.dataset.bound = "1";

    const timeEl = $("rt-time"), phaseEl = $("rt-phase"), roundEl = $("rt-round");
    const startBtn = $("rt-start"), resetBtn = $("rt-reset"), feedback = $("rt-feedback");
    const customWrap = $("rt-custom"), customType = $("rt-custom-type"), customMins = $("rt-custom-mins");
    const notifyBtn = $("rt-notify");

    const PRESETS = {
      sauna: () => [{ label: "Sauna", type: "sauna", secs: 15 * 60, hot: true }],
      cold: () => [{ label: "Cold Plunge", type: "cold_plunge", secs: 3 * 60, icy: true }],
      contrast: () => {
        const phases = [];
        for (let r = 1; r <= 3; r++) {
          phases.push({ label: "Sauna", type: "sauna", secs: 12 * 60, hot: true, round: r });
          phases.push({ label: "Cold Plunge", type: "cold_plunge", secs: 2 * 60, icy: true, round: r });
        }
        return phases;
      },
      custom: () => {
        const mins = Math.max(1, Math.min(120, parseInt(customMins.value, 10) || 20));
        const type = customType.value || "sauna";
        const meta = TYPE_META[type] || { label: type };
        return [{ label: meta.label, type: type, secs: mins * 60, hot: type === "sauna" || type === "red_light", icy: type === "cold_plunge" }];
      }
    };

    let preset = "sauna", phases = PRESETS.sauna(), idx = 0, remaining = phases[0].secs;
    let running = false, tickId = null, endAt = 0, wakeLock = null;

    function fmt(s) {
      const m = Math.floor(s / 60), r = s % 60;
      return m + ":" + String(r).padStart(2, "0");
    }

    function paint() {
      const p = phases[idx];
      timeEl.textContent = fmt(Math.max(0, remaining));
      timeEl.classList.toggle("rt-hot", !!p.hot);
      timeEl.classList.toggle("rt-icy", !!p.icy);
      phaseEl.textContent = p.label;
      roundEl.textContent = p.round ? "Round " + p.round + " of 3 · phase " + (idx + 1) + "/" + phases.length : "";
      startBtn.textContent = running ? "Pause" : (remaining < phases[idx].secs ? "Resume" : "Start");
    }

    function beep(freq, dur) {
      if (!$("rt-sound") || !$("rt-sound").checked) return;
      try {
        const ctx = beep._ctx || (beep._ctx = new (window.AudioContext || window.webkitAudioContext)());
        const osc = ctx.createOscillator(), gain = ctx.createGain();
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0.25, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + dur);
        osc.connect(gain).connect(ctx.destination);
        osc.start();
        osc.stop(ctx.currentTime + dur);
      } catch (e) { /* audio blocked — non-fatal */ }
    }

    function buzz(pattern) {
      const box = $("rt-vibrate");
      if (box && box.checked && navigator.vibrate) navigator.vibrate(pattern);
    }

    function notify(title, body) {
      if (!("Notification" in window) || Notification.permission !== "granted") return;
      try { new Notification(title, { body, icon: "https://cdn.shopify.com/s/files/1/0911/2453/1481/files/ewhq-app-icon-192.png?v=1784987822" }); } catch (e) {}
    }

    function requestWake() {
      if (navigator.wakeLock && navigator.wakeLock.request) {
        navigator.wakeLock.request("screen").then(l => { wakeLock = l; }).catch(() => {});
      }
    }
    function releaseWake() {
      if (wakeLock) { wakeLock.release().catch(() => {}); wakeLock = null; }
    }

    function stopTick() { if (tickId) { clearInterval(tickId); tickId = null; } }

    function complete() {
      running = false;
      stopTick();
      releaseWake();
      beep(880, 0.6); buzz([200, 100, 200, 100, 400]);
      notify("Session complete ✓", "Nice work — it's logged in your Wellness Hub.");
      // Aggregate minutes per modality and log real sessions.
      const byType = {};
      phases.forEach(p => { byType[p.type] = (byType[p.type] || 0) + p.secs; });
      let logged = [];
      if (window.EWHQ) {
        Object.keys(byType).forEach(t => {
          const mins = Math.max(1, Math.round(byType[t] / 60));
          window.EWHQ.logSession({ type: t, minutes: mins });
          logged.push(mins + " min " + ((TYPE_META[t] || { label: t }).label));
        });
      }
      feedback.innerText = "✓ Logged " + logged.join(" + ");
      feedback.classList.add("show");
      idx = 0;
      remaining = phases[0].secs;
      paint();
    }

    function nextPhase() {
      idx++;
      if (idx >= phases.length) { complete(); return; }
      const p = phases[idx];
      remaining = p.secs;
      endAt = Date.now() + remaining * 1000;
      beep(p.icy ? 330 : 660, 0.35); buzz([300]);
      notify(p.label + " — " + fmt(p.secs), p.round ? "Round " + p.round + " of 3" : "Next phase");
      paint();
    }

    function tick() {
      remaining = Math.max(0, Math.round((endAt - Date.now()) / 1000));
      if (remaining <= 0) { nextPhase(); return; }
      paint();
    }

    startBtn.addEventListener("click", () => {
      if (running) {
        running = false;
        stopTick();
        releaseWake();
      } else {
        if (preset === "custom") { phases = PRESETS.custom(); if (idx >= phases.length) idx = 0; if (remaining > phases[idx].secs) remaining = phases[idx].secs; }
        running = true;
        endAt = Date.now() + remaining * 1000;
        tickId = setInterval(tick, 500);
        requestWake();
        beep(660, 0.2);
        feedback.classList.remove("show");
      }
      paint();
    });

    resetBtn.addEventListener("click", () => {
      running = false;
      stopTick();
      releaseWake();
      phases = PRESETS[preset]();
      idx = 0;
      remaining = phases[0].secs;
      feedback.classList.remove("show");
      paint();
    });

    panel.querySelectorAll(".rt-preset").forEach(btn => {
      btn.addEventListener("click", () => {
        panel.querySelectorAll(".rt-preset").forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
        preset = btn.dataset.preset;
        customWrap.hidden = preset !== "custom";
        running = false;
        stopTick();
        releaseWake();
        phases = PRESETS[preset]();
        idx = 0;
        remaining = phases[0].secs;
        paint();
      });
    });

    [customType, customMins].forEach(el => el && el.addEventListener("change", () => {
      if (preset !== "custom" || running) return;
      phases = PRESETS.custom();
      idx = 0;
      remaining = phases[0].secs;
      paint();
    }));

    if (notifyBtn) {
      if (!("Notification" in window)) notifyBtn.style.display = "none";
      else if (Notification.permission === "granted") { notifyBtn.disabled = true; notifyBtn.textContent = "Alerts on ✓"; }
      notifyBtn.addEventListener("click", () => {
        Notification.requestPermission().then(p => {
          if (p === "granted") { notifyBtn.disabled = true; notifyBtn.textContent = "Alerts on ✓"; notify("EWHQ alerts enabled", "We'll ping you at each phase change."); }
        });
      });
    }

    // If the tab was hidden, recompute from the wall clock on return so the
    // timer never drifts.
    document.addEventListener("visibilitychange", () => { if (!document.hidden && running) tick(); });

    paint();
  }

  /* ============ WIRE UP ============ */
  function renderAll() {
    renderBlueprint();
    renderRings();
    renderRecentSessions();
    renderWeeklyGraph();
    renderTrends();
    renderAchievements();
    renderTpiCheckin();
    renderHeatmap();
    renderMicroCheckin();
    renderCreditsStore();
    renderStreakAlert();
    renderGoalTuning();
  }

  initGoalsEditor();
  initLogger();
  initSpotlight();
  initMicroCheckin();
  initCreditsStore();
  initWearableImport();
  initRecoveryTimer();
  renderAll();
  if (window.EWHQ) maybeFireWeeklyRecap();
  else document.addEventListener("ewhq:ready", maybeFireWeeklyRecap, { once: true });
  document.addEventListener("ewhq:change", renderAll);
  document.addEventListener("ewhq:ready", renderAll);

  // Theme editor support: the editor re-renders the section DOM without a
  // page reload, which would otherwise leave the carousel without dots,
  // autoplay, or click handlers ("everything looks erased").
  document.addEventListener("shopify:section:load", () => {
    closeTheater();
    initGoalsEditor();
    initLogger();
    initSpotlight();
    initMicroCheckin();
    initCreditsStore();
    initWearableImport();
    initRecoveryTimer();
    renderAll();
  });

  // Selecting a Video Spotlight block in the editor sidebar flips the
  // carousel to that card so you always see the one you're editing.
  document.addEventListener("shopify:block:select", event => {
    const slide = event.target && event.target.classList && event.target.classList.contains("spot-slide")
      ? event.target
      : null;
    if (!slide) return;
    const track = slide.closest("[data-spot-track]");
    if (track) track.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
  });
});
